import { SQLService } from '../../../services/sql.service';
import { PopoverController } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'ng-cheques-paypal-menu',
  templateUrl: './paypal-menu.component.html',
  styleUrls: ['./paypal-menu.component.styl']
})
export class PayPalMenuComponent implements OnInit {
  constructor(
    public sql: SQLService,
    public popover: PopoverController,
    private router: Router) {
  }
  list:string;
  @Input('enabled') enabled:boolean;
  @Input('production_mode') production_mode:boolean;
  dismissPopover(e) {
    if (this.popover) this.popover.dismiss(e);
  }
  delete() {
    this.dismissPopover('delete');
  }
  disable() {
    this.dismissPopover('disable');
  }
  enable() {
    this.dismissPopover('enable');
  }
  sandbox() {
    this.dismissPopover('sandbox'); 
  }
  production() {
    this.dismissPopover('production');
  }
  ngOnInit() {
  }
}